import React from 'react';
import {MDBModal, MDBModalBody, MDBModalHeader} from "mdbreact";
import {Card, CardBody, CardHeader, Col, Collapse, Row} from "reactstrap";
import {Button, Select} from "semantic-ui-react";
import Cookies from "js-cookie";
import axiosTags from "../../../../axios/axios_tag";
import apiConfig from "../../../../axios/axios_api_services";
import * as common from "../../../../const/Common/CommonFunc";
import * as actionCreator from "../../../../store/Action";
import {connect} from "react-redux";
import {withRouter} from "react-router-dom";
import swal from "sweetalert";
import are_you_sure_icon from "../../../../assets/img/sweet/question.svg";
import * as time_convertor_utils from "../../../../util/TimeConvertor";
import axiosSpace from "../../../../axios/axios_spacetag";
import {DatePicker} from "antd";
import moment from "moment";

const {RangePicker} = DatePicker;

class CreateNotification extends React.Component {

  state = {

    corporateId: null,

    all_branch_list: [],
    branch_options: [],
    branch_index: 0,
    branch_id: 0,

    all_building_list: [],
    building_options: [],
    building_index: 0,
    building_id: 0,

    all_floor_list: [],
    floor_options: [],
    floor_index: 0,
    floor_id: 0,

    all_work_space_list: [],
    workspace_options: [],
    workspace_index: 0,
    workspace_id: 0,

    title: "",
    message: "",
    // title_text_count: 100,
    message_text_count: 500,

    start_date: null,
    end_date: null

  };

  componentDidMount() {
    this.props.systemChangeHandler(5);
    let corporateId = this.props.usr_obj.corporates[0].corporateId;

    this.setState({
      corporateId: corporateId,
      branch_options: [
        {
          key: 0,
          text: "All",
          id: 0,
          value: 0,
        }
      ],
      floor_options: [
        {
          key: 0,
          text: "All",
          value: 0,
        }
      ],
      building_options: [
        {
          key: 0,
          text: "All",
          id: 0,
          value: 0,
        }
      ],
      workspace_options: [
        {
          key: 0,
          text: "All",
          id: 0,
          value: 0,
        }
      ],
      branch_index: 0,
      branch_id: 0,
      building_index: 0,
      building_id: 0,
      floor_index: 0,
      floor_id: 0,
      workspace_index: 0,
      workspace_id: 0

    });
    this.callAllBranches();
    // this.callAllWorkSpace(0,0,0, corporateId);
  }

  callAllBranches = () => {
    const headers = {
      "Authorization": "Bearer " + Cookies.get("68a6102f6ed24899420170004a0273b8")
    };

    this.props.spinnerHandler(true);
    axiosTags.get(apiConfig.CORPORATE_BRANCH(this.props.usr_obj.corporateId), {headers: headers})
      .then(response => {
        if (response.data.success) {
          let branch_options = [
            {
              key: 0,
              text: "All",
              id: 0,
              value: 0,
            }
          ];
          if (response.data.branchList.length !== 0) {
            response.data.branchList.map((branch, index) => {

              const obj = {
                key: index + 1,
                text: branch.name,
                id: branch.branchId,
                value: index + 1,
                // value: branch.branchId
              };
              branch_options.push(obj)
            })
          }
          this.setState({
            branch_options: branch_options,
            all_branch_list: response.data.branchList
          })
        } else {
          this.setState({
            branch_options: []
          })
        }
      })
      .catch(async error => {
        let result = await common.checkErrorResponse(error);
        if (result === 1) {
          this.callAllBranches()
        }
      })
      .finally(fin => {
        this.props.spinnerHandler(false);
      });
  };


  onChangeBranch = (e, {value}) => {

    let b_id = this.state.branch_options[value].id;

    this.setState({
      branch_index: value,
      branch_id: b_id,
      building_index: 0,
      building_id: 0,
      floor_options: [
        {
          key: 0,
          text: "All",
          value: 0,
        }
      ],
      floor_index: 0,
      floor_id: 0,
      workspace_options: [
        {
          key: 0,
          text: "All",
          id: 0,
          value: 0,
        }
      ],
      workspace_index: 0,
      workspace_id: 0
    });
    this.loadBuildings( value );
  };

  loadBuildings = ( index ) => {

    let building_options = [
      {
        key: 0,
        text: "All",
        id: 0,
        value: 0,
      }
    ];
    let buildings = null;
    if(index !== 0) {
      let branchOptions = this.state.all_branch_list;
      if(branchOptions) {
        let branchOption = branchOptions[index-1];
        buildings = branchOption.buildings;
        if(buildings) {
          buildings.map((result, index)=>{
            const obj = {
              key: index + 1,
              text: result.name,
              id: result.buildingId,
              value: index + 1,
            };
            building_options.push(obj);
          });
        }
      }
    }
    this.setState({
      building_options: building_options,
      all_building_list: buildings,
      building_index: 0,
      floor_options: [
        {
          key: 0,
          text: "All",
          value: 0,
        }
      ],
      floor_index: 0,
      floor_id: 0,
      workspace_options: [
        {
          key: 0,
          text: "All",
          id: 0,
          value: 0,
        }
      ],
      workspace_index: 0,
      workspace_id: 0
    });

  };

  onChangeBuilding = (e, { value }) => {
    let b_id = this.state.building_options[value].id;
    this.setState({
      building_index: value,
      building_id: b_id,
      floor_index: 0
    });
    this.loadFloors( value );
  };

  loadFloors = ( index ) => {

    let floor_options = [
      {
        key: 0,
        text: "All",
        value: 0,
      }
    ];
    let floors = [];
    if(index !== 0) {
      let floorOptions = this.state.all_building_list;
      if(floorOptions) {
        let floorOption = floorOptions[index-1];
        floors = floorOption.floors;
        if(floors) {
          floors.map((result, index)=>{
            const obj = {
              key: index + 1,
              text: result.description,
              id: result.floor_id,
              value: index + 1,
            };
            floor_options.push(obj);
          });
        }
      }
    }
    this.setState({
      all_floor_list: floors,
      floor_options: floor_options,
      floor_index: 0
    });

  };

  onChangeFloor = (e, {value}) => {
    this.setState({
      floor_id: this.state.floor_options[value].id,
      floor_index: value,
      workspace_id: 0,
      workspace_index: 0
    });
    this.callAllWorkSpace(this.state.branch_id, this.state.building_id, this.state.floor_options[value].id, this.state.corporateId);
  };

  callAllWorkSpace = (branchId, buildingId, floorId, corporateId) => {

    const headers = {
      "Authorization": "Bearer " + Cookies.get("68a6102f6ed24899420170004a0273b8"),
      "Content-Type": "application/json"
    };

    let obj = {
      branchId : branchId,
      buildingId : buildingId,
      floorId : floorId,
    };

    this.props.spinnerHandler(true);
    axiosTags.post(apiConfig.ST_WORKSPACE_FILTER({ corporateId:corporateId }), obj, {headers: headers})
      .then(response => {
        if (response.data.success) {

          let ws_list = [];

          let s_obj = {
            key: 0,
            text: "All",
            id: 0,
            value: 0,
          };

          ws_list.push(s_obj);

          let d_list = response.data.workSpaceList;

          d_list.map((r, i)=>{
            let workSpaceId = r.workSpaceId;
            let description = r.description;
            let obj = {
              key: i+1,
              text: description,
              id: workSpaceId,
              value: i+1,
            };
            ws_list.push(obj);
          });

          this.setState({
            all_work_space_list: d_list,
            workspace_options: ws_list,
          });
        } else {

        }
      })
      .catch(async error => {
        let result = await common.checkErrorResponse(error);
        if (result === 1) {
          this.callAllWorkSpace(branchId, buildingId, floorId, corporateId)
        }
      })
      .finally(fin => {
        this.props.spinnerHandler(false);
      });
  };

  onChangeWorkspace = (e, { value }) => {
    this.setState({
      workspace_id: this.state.workspace_options[value].id,
      workspace_index: value
    });
  };

  onChangeNotificationTitle = e => {
    let value = e.target.value;
    this.setState({
      title: value
    })
  };

  onChangeNotificationMessage = e => {
    let value = e.target.value;
    let count = 500 - value.length;
    if(count < 0) {
      this.setState({
        message: value.substring(0, value.length + count),
        message_text_count: 0
      })
    } else {
      this.setState({
        message: value,
        message_text_count: count
      })
    }
  };

  sendPushNotification = () => {
    (this.state.start_date === '' || this.state.start_date === null || this.state.start_date === undefined)?
      common.notifyMessage("Please select date range"):
      this.state.title.trim() === ''? common.notifyMessage("Please enter notification title"):
        this.state.message.trim() === ''? common.notifyMessage("Please enter notification message"):
          this.sendPushNotification_();
  };

  sendPushNotification_ = () => {

    let branchIndex = this.state.branch_index;
    let buildingIndex = this.state.building_index;
    let floorIndex = this.state.floor_index;
    let workspaceIndex = this.state.workspace_index;
    let message = "";
    if(workspaceIndex!==0) {
      let description = this.state.all_work_space_list[workspaceIndex-1].description;
      message = "Are you sure to send this notification to the workspace named " + description;
    } else if(floorIndex !== 0) {
      let description = this.state.all_floor_list[floorIndex-1].description;
      message = "Are you sure to send this notification to the all workspaces in the floor named " + description;
    } else if(buildingIndex!==0) {
      let description = this.state.all_building_list[buildingIndex-1].name;
      message = "Are you sure to send this notification to the all workspaces in the building named " + description;
    } else if(branchIndex!==0) {
      let description = this.state.all_branch_list[branchIndex-1].name;
      message = "Are you sure to send this notification to the all workspaces in the branch named " + description;
    } else {
      message = "Are you sure to send this notification to the all workspaces in the corporate";
    }

    swal({
      title: message + "?",
      icon: are_you_sure_icon,
      closeOnClickOutside: false,
      buttons: {
        cancel: 'Cancel',
        dangerMode: {
          text: "Yes",
          value: "action",
          className: "okay-btn"
        }
      },
    })
      .then((value) => {
        switch (value) {
          case "action":
            this.sendPushNotification__();
            break;
          default:
        }
      });
  };

  sendPushNotification__ = () => {

    let obj = {
      title: this.state.title,
      body: this.state.message,
      notificationType: "SPACE",
      branchId: this.state.branch_id,
      buildingId: this.state.building_id,
      floorId: this.state.floor_id,
      workSpaceId: this.state.workspace_id,
      startDate : time_convertor_utils.DateObjTOStringYYYYMMdd(new Date(this.state.start_date)),
      endDate : time_convertor_utils.DateObjTOStringYYYYMMdd(new Date(this.state.end_date))
    };

    const headers = {
      "Authorization": "Bearer " + Cookies.get("68a6102f6ed24899420170004a0273b8"),
      "Content-Type": "application/json"
    };

    this.props.spinnerHandler(true);
    axiosSpace.put(apiConfig.ST_SEND_PUSH_NOTIFICATION({ corporateId:this.state.corporateId }), obj, {headers: headers})
      .then(response => {
        if(response.status === 200) {
          if (response.data.success) {
            common.warningAlert(response.data.message, 0);
            this.cleanInput();
          } else {
            common.warningAlert(response.data.message, 1);
          }
        }
      })
      .catch(async error => {
        let result = await common.checkErrorResponse(error);
        if (result === 1) {
          this.sendPushNotification__();
        }
      })
      .finally(fin => {
        this.props.spinnerHandler(false);
      });
  };

  cleanInput = () => {
    this.setState({
      title: "",
      message: "",
      message_text_count: 500,
      start_date: null,
      end_date: null
    })
  };

  onChangeDateRange = (date, dateString) => {
    if (dateString[0] !== "" || dateString[1] !== "") {
      let start = new Date(dateString[0]);
      let end = new Date(dateString[1]);
      start = (start.toISOString()).split("T")[0];
      end = (end.toISOString()).split("T")[0];
      this.setState({
        start_date: start,
        end_date: end
      });
    }
  };

  toggle = () => {};

  render() {
    let { branch_options, building_options, floor_options, workspace_options, branch_index, building_index, floor_id, workspace_id, floor_index, workspace_index, title, message } = this.state;

    let dateRange = null;

    if (this.state.start_date !== null && this.state.start_date !== undefined && this.state.start_date !== "") {
      let startdate = this.state.start_date;
      let enddate = this.state.end_date;
      dateRange = [moment(startdate), moment(enddate)];
    } else {
      dateRange = null;
    }


    return(
      <div>
        <MDBModal isOpen={this.props.isOpen} toggle={this.toggle} size="xl">
          <MDBModalHeader className={"title"}
                          toggle={this.props.closeModal}>Create New Notification</MDBModalHeader>
          <MDBModalBody>
            <div>
              <Card>
                <CardHeader>
                  Filter Workspace
                </CardHeader>
                <Collapse isOpen={true} id="collapseExample">
                  <CardBody>
                    <Row>
                      <Col>
                        <div>
                          <div>Branch</div>
                          <Select
                            placeholder='Select branch'
                            options={ branch_options }
                            value={ branch_index }
                            onChange={ this.onChangeBranch }
                          />
                        </div>
                      </Col>
                      <Col>
                        <div>
                          <div>Building</div>
                          <Select
                            placeholder='Select building'
                            options={ building_options }
                            value={ building_index }
                            onChange={ this.onChangeBuilding }
                          />
                        </div>
                      </Col>
                      <Col>
                        <div>
                          <div>Floor</div>
                          <Select
                            placeholder='Select floor'
                            options={ floor_options }
                            value={ floor_index }
                            onChange={ this.onChangeFloor }
                          />
                        </div>
                      </Col>
                      <Col>
                        <div>
                          <div>Workspace</div>
                          <Select
                            placeholder='Select workspace'
                            options={ workspace_options }
                            value={ workspace_index }
                            onChange={ this.onChangeWorkspace }
                          />
                        </div>
                      </Col>
                    </Row>
                  </CardBody>
                </Collapse>
              </Card>
              <Card>
                <CardHeader>
                  New Notification
                </CardHeader>
                <Collapse isOpen={true} id="collapseExample">
                  <CardBody>
                    <div className="ui form">

                      <div className="field notification-range-picker">
                        <label>Date Range</label>
                        <RangePicker
                          format="YYYY-MM-DD"
                          value={dateRange}
                          onChange={ this.onChangeDateRange }
                        />
                      </div>

                      <div className="field">
                        <label>Title</label>
                        <input
                          placeholder='Enter notification title'
                          value={ title }
                          onChange={ this.onChangeNotificationTitle }
                        />
                      </div>
                      <div className="field">
                        <label>Message</label>
                        <textarea
                          autoComplete="off"
                          spellCheck="false"
                          placeholder="Enter notification message here.."
                          value={ message }
                          onChange={ this.onChangeNotificationMessage }>
                        </textarea>
                        <div className={ "text-right" }>
                          <span style={{ fontWeight: "bold" }}>{ this.state.message_text_count }</span>{" "}/{" 500"}
                        </div>
                      </div>
                    </div>
                    <div className={'notification_send_btn_panel text-right'}>
                      <Button
                        className="px-5"
                        onClick={ this.sendPushNotification }
                      >Send Now</Button>
                    </div>
                  </CardBody>
                </Collapse>
              </Card>
            </div>
          </MDBModalBody>
        </MDBModal>
      </div>
    )
  }

}

const mapStateToProps = (state) => ({
  usr_obj: state.userReducer.user,
});

const mapDispatchToProps = (dispatch) => {
  return {
    spinnerHandler: (data) => dispatch(actionCreator.spinnerHandler(data)),
    workspaceHandler: (data) => dispatch(actionCreator.workspaceSaveHandler(data)),
    workspaceRemove: () => dispatch(actionCreator.workspaceRemoveHandler()),
    systemChangeHandler: (data) => dispatch(actionCreator.systemChangeHandler(data)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(CreateNotification));
